import { Text } from "@mantine/core";

export const SeoFooter = () => (
  <Text fz="medium">
    <Text span c="black" fw="bold">
      fs-checklist-studio
    </Text>{" "}
    is free and stores your data locally -- no signup required and no software to download.
  </Text>
);
